import React from "react";
export const LocalVideo = () => {
  return (
    <div
      id="local"
      className="d-flex justify-content-center position-absolute local"
    ></div>
  );
};
